var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "transfer-dom", rawName: "v-transfer-dom" }],
      attrs: { "data-transfer": _vm.transfer }
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.mask
          ? _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible"
                }
              ],
              class: _vm.maskClasses,
              style: _vm.maskStyle,
              on: { click: _vm.handleMask }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.wrapClasses, on: { click: _vm.handleWrapClick } },
        [
          _c("transition", { attrs: { name: _vm.transitionName } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible"
                  }
                ],
                class: _vm.classes,
                style: _vm.mainStyles
              },
              [
                _c("div", { ref: "content", class: _vm.contentClasses }, [
                  _vm.closable
                    ? _c(
                        "a",
                        {
                          staticClass: "ivu-drawer-close",
                          on: { click: _vm.close }
                        },
                        [
                          _vm._t("close", function() {
                            return [
                              _c("Icon", { attrs: { type: "ios-close" } })
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showHead
                    ? _c(
                        "div",
                        { class: [_vm.prefixCls + "-header"] },
                        [
                          _vm._t("header", function() {
                            return [
                              _c(
                                "div",
                                { class: [_vm.prefixCls + "-header-inner"] },
                                [_vm._v(_vm._s(_vm.title))]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: [_vm.prefixCls + "-body"], style: _vm.styles },
                    [_vm._t("default")],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm.draggable &&
                (_vm.placement === "left" || _vm.placement === "right")
                  ? _c(
                      "div",
                      {
                        staticClass: "ivu-drawer-drag",
                        class: "ivu-drawer-drag-" + _vm.placement,
                        on: { mousedown: _vm.handleTriggerMousedown }
                      },
                      [
                        _vm._t("trigger", function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "ivu-drawer-drag-move-trigger" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ivu-drawer-drag-move-trigger-point"
                                  },
                                  [_c("i"), _c("i"), _c("i"), _c("i"), _c("i")]
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c8be125", { render: render, staticRenderFns: staticRenderFns })
  }
}